<template>
    <div class="post-block">
        <router-link class="img-container" :to="slug">
            <wp-image v-if="thumbnail"
                      :image="thumbnail"
                      size-sd="blog-thumbnail-sd"
                      size-hd="blog-thumbnail-hd"
                      class="thumbnail" />
            <div v-else class="post-missing-image-block">
                <span>Blog Post</span>
            </div>
            <div class="overlay">
                <p class="text">
                    Read Post
                </p>
            </div>
        </router-link>
        <div class="content-container">
            <router-link class="title" :to="slug">
                {{ title }}
            </router-link>
            <p class="date">
                {{ getDate }} {{ categoryList }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PostBlock",
        props: {
            id: Number | String,
            date: String,
            thumbnail: Boolean | Array | Number,
            link: String,
            slug: String,
            title: String,
            index: Number,
            categories: Boolean | Array
        },
        computed: {
            getDate() {
                const date = new Date(this.date);
                return date.toLocaleDateString('en-US').replace(new RegExp('\\/', 'g'), '.');
            },
            categoryList() {
                if (!this.categories) return ''

                if (this.categories.length === 1) {
                    if (typeof this.categories[0] === 'object') {
                        return `| ${this.categories[0].name}`
                    }

                    return `| ${this.categories[0]}`
                }

                if (typeof this.categories[0] === 'object') {
                    const cats = this.categories.map((category) => {
                        return category.name
                    });
                    return `| ${cats.join(', ')}`
                }

                return `| ${this.categories.join(', ')}`
            }
        }
    }
</script>

<style lang="scss" scoped>

    .post-block{

        &:hover{
            .thumbnail{
                transform: scale(1.1);
            }

            .title{
                color: $color2;
            }
        }
    }

    .img-container{
        display: block;
        overflow: hidden;

        .thumbnail{
            width: 100%;
            height: auto !important;
            transition: all .3s ease-in-out;
        }
    }

    .content-container{
        padding: 20px 10px;
    }

    .title{
        color: #fff;
        text-decoration: none;
        transition: all .3s ease-in-out;
    }

    .date{
        color: $color4;
        font-size: 17px;
        font-weight: 600;
    }

</style>